import { StandardAlert } from '@cimplico/components';
import { useState } from 'react';
import { CreateFYIEntitiesResponse } from '../../../../../../../queries/use-create-fyi-entities';
import { formatErrorMessages, formatSuccessMessages } from './utils';
import plural from '../../../../../../../utilities/plural';

type FYIEntitiesOnboardAlertProps = {
    success?: CreateFYIEntitiesResponse;
    errors?: { [entityName: string]: string[] };
    onSuccessAlertClose: () => void;
    onErrorAlertClose: () => void;
};

function FYIEntitiesOnboardAlert({ success, errors, onSuccessAlertClose, onErrorAlertClose }: FYIEntitiesOnboardAlertProps): JSX.Element {
    const [viewMore, setViewMore] = useState(false);

    const errorMessages = formatErrorMessages(errors);
    const successMessages = formatSuccessMessages(success);

    return (
        <div className="mb-4 flex flex-col gap-2">
            {successMessages.length > 0 && (
                <StandardAlert
                    type="success"
                    title="Successfully completed the following onboarding actions:"
                    description={successMessages}
                    onClose={onSuccessAlertClose}
                >
                    <></>
                </StandardAlert>
            )}
            {errorMessages.length > 0 && (
                <StandardAlert
                    type="error"
                    title={`The following ${plural(errorMessages.length, 'error occurs', 'errors occur')} while onboarding FYI entities:`}
                    description={!viewMore ? errorMessages.slice(0, 2) : errorMessages}
                    onClose={onErrorAlertClose}
                >
                    {errorMessages.length > 2 && !viewMore && (
                        <StandardAlert.Button onClick={(): void => setViewMore(!viewMore)}>View more</StandardAlert.Button>
                    )}
                    {errorMessages.length > 2 && viewMore && (
                        <StandardAlert.Button onClick={(): void => setViewMore(!viewMore)}>View less</StandardAlert.Button>
                    )}
                </StandardAlert>
            )}
        </div>
    );
}

export default FYIEntitiesOnboardAlert;
